import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './section.types';
import * as constants from './section.constants';

export const sectionReducer = generateResourceReducer<types.ISection>({
  STORE: constants.STORE_SECTION,
  CLEAR: constants.CLEAR_SECTION,
});
